import { Controller } from "@hotwired/stimulus"

// Initializes Bootstrap 3 tooltips and popovers within scope.
// Tears down before Turbo caches to prevent orphaned tooltip elements.
export default class extends Controller {
  connect() {
    const $el = jQuery(this.element)
    $el.find('a[rel~=popover], .has-popover').popover()
    $el.find('a[rel~=tooltip], .has-tooltip').tooltip({ container: 'body' })

    this.beforeCacheHandler = () => this.cleanup()
    document.addEventListener('turbo:before-cache', this.beforeCacheHandler)
  }

  disconnect() {
    document.removeEventListener('turbo:before-cache', this.beforeCacheHandler)
    this.cleanup()
  }

  cleanup() {
    const $el = jQuery(this.element)
    $el.find('a[rel~=tooltip], .has-tooltip').tooltip('destroy')
    $el.find('a[rel~=popover], .has-popover').popover('destroy')
  }
}
